// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-download {
    display: inline-block;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
    color: black;
}

#content .card svg {
    height: 1em;
}

.hiddenRow {
    display:none;
}

.oddTableLine {
    background-color: var(--sk_oddLine);
}

.evenTableLine {
    background-color: var(--sk_evenLine);
}

.selectedTableLine {
    background-color: var(--sk_selected) !important;
}

.new-user {
    display: flex;
    /*margin: 0 15px;*/
    padding: 8px 0;
    align-items: center;
    justify-content: space-between;
}

.new-user input:first-child{
    margin: 0 20px 0 0 ;
}

/*.submit-new-user {*/
/*    background-image: url(../res/newIcone.svg);*/
/*    background-repeat: no-repeat;*/
/*    height: 14px;*/
/*    overflow: visible;*/
/*    vertical-align: -0.125em;*/
/*    font-size: 0;*/
/*    border: 0;*/
/*}*/

.new-user label {
    display: none;
}

body .open {
    display: block;
}

.formthis {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.formthis .form-group {
    width: 100%;
}

.ActiveUserEnable .buttonUserEnable {
    display: none;
}

.ActiveUserEnable .buttonUserDisable {
    display: inline-block;
}
.buttonUserEnable {
    display: inline-block;
}

.buttonUserDisable {
    display: none;
}

.ActiveUserLock .compteUnlock {
    display: inline-block;
}

.ActiveUserLock .compteLock {
    display: none;
}
.compteUnlock {
    display: none;
}

.buttonCompteLock {
    display: inline-block;
}

body .new-user {
    justify-content: space-between;
}

.container__information__users:hover .tooltip {
    display: inline-block;
    opacity: 1;
    top: -77px;
}

.container__information__users {
    position: relative;
}

.container__information__users .arrow {
    top: 50%;
}

.inputError {
    border: solid 1px red;
    box-shadow: 0px 0px 5px 2px rgba(255, 0, 0, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/styles/users.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB,kDAAkD;AAClD,oCAAoC;AACpC,oBAAoB;AACpB,yBAAyB;AACzB,gCAAgC;AAChC,oBAAoB;AACpB,iBAAiB;AACjB,IAAI;;AAEJ;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD","sourcesContent":[".fa-download {\n    display: inline-block;\n    height: 1em;\n    overflow: visible;\n    vertical-align: -0.125em;\n    color: black;\n}\n\n#content .card svg {\n    height: 1em;\n}\n\n.hiddenRow {\n    display:none;\n}\n\n.oddTableLine {\n    background-color: var(--sk_oddLine);\n}\n\n.evenTableLine {\n    background-color: var(--sk_evenLine);\n}\n\n.selectedTableLine {\n    background-color: var(--sk_selected) !important;\n}\n\n.new-user {\n    display: flex;\n    /*margin: 0 15px;*/\n    padding: 8px 0;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.new-user input:first-child{\n    margin: 0 20px 0 0 ;\n}\n\n/*.submit-new-user {*/\n/*    background-image: url(../res/newIcone.svg);*/\n/*    background-repeat: no-repeat;*/\n/*    height: 14px;*/\n/*    overflow: visible;*/\n/*    vertical-align: -0.125em;*/\n/*    font-size: 0;*/\n/*    border: 0;*/\n/*}*/\n\n.new-user label {\n    display: none;\n}\n\nbody .open {\n    display: block;\n}\n\n.formthis {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n}\n\n.formthis .form-group {\n    width: 100%;\n}\n\n.ActiveUserEnable .buttonUserEnable {\n    display: none;\n}\n\n.ActiveUserEnable .buttonUserDisable {\n    display: inline-block;\n}\n.buttonUserEnable {\n    display: inline-block;\n}\n\n.buttonUserDisable {\n    display: none;\n}\n\n.ActiveUserLock .compteUnlock {\n    display: inline-block;\n}\n\n.ActiveUserLock .compteLock {\n    display: none;\n}\n.compteUnlock {\n    display: none;\n}\n\n.buttonCompteLock {\n    display: inline-block;\n}\n\nbody .new-user {\n    justify-content: space-between;\n}\n\n.container__information__users:hover .tooltip {\n    display: inline-block;\n    opacity: 1;\n    top: -77px;\n}\n\n.container__information__users {\n    position: relative;\n}\n\n.container__information__users .arrow {\n    top: 50%;\n}\n\n.inputError {\n    border: solid 1px red;\n    box-shadow: 0px 0px 5px 2px rgba(255, 0, 0, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
